export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-12.3ad0b712.png";